/**
 * Leadership briefing access — Clifford Chance only for now.
 * Gate by Salesforce ACCOUNT_ID (not customer name). Keep in sync with:
 *   server/services/customerBriefing/access.js
 */

/** Salesforce ACCOUNT_IDs for Clifford Chance (primary + secondary merged roster). */
const CLIFFORD_CHANCE_ACCOUNT_IDS = Object.freeze([
  '0011B00002CbVpIQAV',
  '0014O00002MGctqQAD'
]);

const CLIFFORD_CHANCE_ACCOUNT_ID_SET = new Set(CLIFFORD_CHANCE_ACCOUNT_IDS);

/** Fixed link name that always opens the briefing (/briefings/clifford-chance). */
const CLIFFORD_CHANCE_BRIEFING_SLUG = 'clifford-chance';

const normalizeAccountIds = (...sources) => {
  const out = [];
  const seen = new Set();
  const push = (value) => {
    const id = String(value || '').trim();
    if (!id || seen.has(id)) return;
    seen.add(id);
    out.push(id);
  };
  for (const source of sources) {
    if (Array.isArray(source)) source.forEach(push);
    else if (source != null && source !== '') push(source);
  }
  return out;
};

const accountIdsOnAllowlist = (accountIds) => (
  normalizeAccountIds(accountIds).some((id) => CLIFFORD_CHANCE_ACCOUNT_ID_SET.has(id))
);

/** URL form of an admin account name: "Clifford Chance LLP" -> "clifford-chance-llp". Mirrors the server. */
export const slugifyName = (name) => String(name || '')
  .normalize('NFKD')
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, '-')
  .replace(/^-+|-+$/g, '');

/** Briefing page slug when any of the customer's ACCOUNT_IDs is allowlisted; otherwise null. */
export const briefingSlugForAccountIds = (...sources) => (
  accountIdsOnAllowlist(normalizeAccountIds(...sources)) ? CLIFFORD_CHANCE_BRIEFING_SLUG : null
);
